import React from "react";
import Container from "../../components/container";
import HeroSmall from "../../components/hero-small-project";

const Coinis = props => (
  <main>
    <HeroSmall 
      name="abago.com"
      title="Flight Search / Online Travel Agency" 
      desc="Book cheap flight tickets" 
    /> 

    <Container customClassName="project-padding">
      <img src="/static/abago-logo.svg" className="project-logo" alt="Abago.com" />
      <p>Based in Montenegro, Abago is primarily an IT company, fully dedicated to unlocking the potential of travel innovations and simplifying the process of online booking. </p>
      <p>We are a creative customer oriented team who is constantly working on seeking innovative solutions regarding traveling and simplifying the process of booking flights by providing personalized solutions at competent prices.</p>
      <p>As a group of young enthusiasts we are dedicated to making a customer’s experience as enjoyable as possible and provide flights and accommodations all over the world. Our platform allows users to choose over 5,000 flights daily and more than 450 airlines and the needs of the customers are placed at the core of our business.</p>
      <p>Our vision us to strengthen our position within the online travel market by providing quality, creative, competitive and technology responsible services in the sector, and to make it a preferable flight booking address for nomads, birds of passage, business or leisure travelers, and the like.</p>
      <p>Among all of this, customers will be able to choose their desired destination with our intelligent suggestive tech that can select places on the map based on weather, overnight flight preferences, intention, mood, etc.</p>
      <p>Abago is an excellent solution for a personal travel manager because we provide reliable and secure services. </p>
      <p>More at: <a href="https://abago.com" target="_blank">abago.com</a></p>
    </Container>
  </main>
);

export default Coinis;



// WEBPACK FOOTER //
// ./src/pages/project/abago.js